import { render } from "./CmsSpecialPageDetail.vue?vue&type=template&id=74bc9ccb&scoped=true&ts=true"
import script from "./CmsSpecialPageDetail.vue?vue&type=script&lang=ts"
export * from "./CmsSpecialPageDetail.vue?vue&type=script&lang=ts"

import "./CmsSpecialPageDetail.vue?vue&type=style&index=0&id=74bc9ccb&lang=scss"
import "./CmsSpecialPageDetail.vue?vue&type=style&index=1&id=74bc9ccb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bc9ccb"]])

export default __exports__